import { render, staticRenderFns } from "./UserFormLayout.vue?vue&type=template&id=41ff768e"
import script from "./UserFormLayout.vue?vue&type=script&lang=js"
export * from "./UserFormLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports